import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute
 *
 * Redirects unauthenticated users to /signin.
 * Preserves the originally intended URL so the user is sent there after sign in.
 * Renders nothing during auth initialization to avoid redirect flicker.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Wait for auth state to resolve before making a routing decision.
  // Rendering null here avoids flashing the signin page for authenticated users.
  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
